let displayTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? "UTC";

const isValidTimeZone = (value: string) => {
  try {
    new Intl.DateTimeFormat(undefined, { timeZone: value });
    return true;
  } catch {
    return false;
  }
};

export const getDisplayTimeZone = (): string => displayTimeZone;

export const setDisplayTimeZone = (nextTimeZone: string): void => {
  if (!nextTimeZone || nextTimeZone === displayTimeZone) {
    return;
  }

  if (!isValidTimeZone(nextTimeZone)) {
    console.warn(`Ignoring invalid time zone value: ${nextTimeZone}`);
    return;
  }

  displayTimeZone = nextTimeZone;
};
